import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon22: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 20" width={width} height={height} {...props}>
      <Path
        d="M10 0C11.243 0 12.455 0.227001 13.592 0.664001C13.849 0.764001 13.978 1.053 13.879 1.311C13.779 1.568 13.49 1.69699 13.232 1.59799C12.21 1.20399 11.12 1 10 1C5.029 1 1 5.029 1 10C1 14.971 5.029 19 10 19C13.673 19 16.935 16.779 18.318 13.444C18.424 13.189 18.716 13.068 18.971 13.173C19.226 13.279 19.347 13.571 19.242 13.827C17.706 17.533 14.081 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM19.137 2.16101C19.328 1.96001 19.644 1.952 19.844 2.142C20.045 2.332 20.053 2.649 19.863 2.849L10.363 12.853C10.16 13.066 9.816 13.059 9.623 12.837L6.134 8.82901C5.953 8.62001 5.975 8.30499 6.183 8.12299C6.391 7.94199 6.707 7.964 6.888 8.172L10.016 11.765L19.137 2.16101Z"
        fill="#73C177"
      />
    </Icon>
  )
}
